import { render } from "./nod.vue?vue&type=template&id=751cb341"
import script from "./nod.vue?vue&type=script&lang=js"
export * from "./nod.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__